import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, mapTo, tap } from 'rxjs/operators';
import { Users } from '../model/users';
import { SharedService } from './shared.service';
import { environment } from '../../environments/environment';
const gettoken_url = `${environment.usertokenUrl}/token`;
export interface AuthResponseData{
  access_token:string;
  expires_in:number
  // refresh_token:string
}
export interface User {
  name: string ;
  password:string;
}
@Injectable({
  providedIn: 'root'
})


export class AuthService {

  private readonly ACCESS_TOKEN='ACCESS_TOKEN';
  private readonly REFRESH_TOKEN='REFRESH_TOKEN';
  isloggedIn=false
  loggedUser:any
  user:Users
  clearTimeout:any
  httpOptions = {
    headers: new HttpHeaders({
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Headers':
        'Origin,X-Requested-With,Content-Type,Accept,GET',
      'Access-Control-Allow-Methods': 'GET',
      'Content-Type': 'application/json',
    }),
  };

  constructor(private router: Router,private http:HttpClient,private sharedService:SharedService) {
    
   }

  login(username:any,password:any){
    
    const data1="username="+username+"&password="+password+"&grant_type=password";
    var reqHeader=new HttpHeaders({'Content-Type':'application/x-www-urlencoded','No-Auth':'True'});
    return this.http.post<AuthResponseData>(`${gettoken_url}`,data1,{headers:reqHeader})

    }
    
  
  
      handleUser(response:any)
      {
        this.storeToken(response.access_token)
        //console.log(response.expires)
        //this.sharedService.gettokenExpireDate(+response.expires_in * 1000);
        localStorage.setItem('expire_In',(response.expires_in * 1000).toString())
        const expireDate=new Date(
          new Date().getTime() + +response.expires_in * 1000
        );  
        this.autoLogout(+response.expires_in * 1000);
           
      }
      storeToken(token:any)
      {
        localStorage.setItem('userToken',token)
       //localStorage.setItem('CurrentUser',this.user.username)
  
      }
      getToken()
      {
            if(localStorage.getItem('userToken')!=null)
            {
              return true
            }
            else 
            return false
      }

  
  checkUserislogged()
  {
    if(!this.getToken())
    {
      this.router.navigate(['/']);
    }
    else{
    let date=new Date().getTime();
   // let expirationDate=new Date(this.sharedService.tokenExpireDate).getTime();
     let expirationDate:number= parseInt(localStorage.getItem('expire_In')!)
    // console.log(expirationDate)
    // console.log(date)
  
    this.autoLogout(date-expirationDate);
    }
  }
  autoLogout(expirationDate:number)
  {
    // console.log(expirationDate)
    // this.clearTimeout=setTimeout(()=>{
    //   this.logOut();
    // },expirationDate)

  }
  logOut()
  {
    localStorage.removeItem('userToken');
    localStorage.removeItem('userDetails');
    localStorage.removeItem('expire_In');
    this.router.navigate(['/']);
    // if(this.clearTimeout)
    // {
    //   clearTimeout(this.clearTimeout);
    // }
  }

  
}
